import React from "react";
import { Redirect } from "react-router";
import _ from 'lodash'
import { gql, graphql, compose } from "react-apollo";
import withUser from "./withUser";
import withLoggedUser from "./withLoggedUser";
import queryStr from 'querystring'


const FACEBOOK_APP_ID = "1647768991999860";
const FACEBOOK_API_VERSION = "v3.1"; // e.g. v2.10

const AUTHENTICATE_FACEBOOK_USER = gql`
  mutation AuthenticateUserMutation($facebookToken: String!) {
    authenticateUser(facebookToken: $facebookToken) {
      token
    }
  }
`;

const withAuthen = WrappedComponent => {
  return compose(
    graphql(AUTHENTICATE_FACEBOOK_USER, { name: "authenticateUserMutation" }),
    withLoggedUser,
    withUser
  )(
    class Authen extends React.Component {
      componentDidMount() {
        this._initializeFacebookSDK();
      }

      _initializeFacebookSDK() {
        window.fbAsyncInit = function() {
          window.FB.init({
            appId: FACEBOOK_APP_ID,
            cookie: true, // enable cookies to allow the server to access the session
            version: FACEBOOK_API_VERSION // use Facebook API version 2.10
          });
        };

        // Load the SDK asynchronously
        (function(d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s);
          js.id = id;
          js.src = "//connect.facebook.net/en_US/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
      }

      _handleFBLogin = () => {
        window.FB.login(
          response => {
            this._facebookCallback(response);
          },
          { scope: "public_profile,email" }
        );
      };

      _facebookCallback = async facebookResponse => {
        if (facebookResponse.status === "connected") {
          const facebookToken = facebookResponse.authResponse.accessToken;
          const graphcoolResponse = await this.props.authenticateUserMutation({
            variables: { facebookToken }
          });
          const graphcoolToken = graphcoolResponse.data.authenticateUser.token;
          localStorage.setItem("graphcoolToken", graphcoolToken);
          window.location.reload();
        } else {
          console.warn(`User did not authorize the Facebook application.`);
        }
      };

      _isLoggedIn = () => {
        return (
          this.props.loggedUserQuery.loggedInUser &&
          this.props.loggedUserQuery.loggedInUser.id &&
          this.props.loggedUserQuery.loggedInUser.id !== ""
        );
      };

      _logout = () => {
        localStorage.removeItem("graphcoolToken");
        window.location.reload();
      };
      render() {
        const search = _.replace(_.get(this.props, "location.search"), "?", "");
        if (search) {
          const params = queryStr.parse(search);
          if (params.post) {
            return <Redirect to={`/posts/${params.post}`} />;
          }
        }

        if (this._isLoggedIn()) {
          return <WrappedComponent {...this.props} logout={this._logout} />;
        } else {
          return this.renderLoggedOut();
        }
      }

      renderLoggedOut() {
        return (
          <div className="container center-align">
            <h1>Congrats </h1>
            <a
              className="waves-effect waves-light btn"
              onClick={this._handleFBLogin}
            >
              <i className="fab fa-facebook-f right" />
              Log in with Facebook
            </a>
            <p>Log in to create new posts</p>
          </div>
        );
      }
    }
  );
};

export default withAuthen;



// WEBPACK FOOTER //
// ./src/templates/authenticate/withAuthen.js